module.exports = __webpack_public_path__ + "static/media/paypal-seeklogo.com.fde975ce.svg";